<template>
  <div
    class="main-wrapper"
  >
    <tabs-layout
      :config="detailsConfig"
      :create-mode="$route.query.category === 'request_new'"
    />
  </div>
</template>

<script>
import TabsLayout from '@/global/components/view-layouts/tabs-layout/views/TabsLayout.vue'
import store from '@/global/store'
import roadInformation from '../../common/config/edit/roadInformation'
import TabActionButtonsWithTitle from '@/global/components/view-layouts/tabs-layout/components/TabActionButtonsWithTitle.vue'

export default {
  name: 'RoadDetails',

  components: {
    TabsLayout
  },

  mixins: [
    roadInformation
  ],

  data () {
    return {
      informationAboutRouteComponent: () => import('../../road-information/components/InformationAboutRoute.vue'),
      drawRoadRegulationComponent: () => import('../../road-information/components/DrawRoadRegulation.vue'),
      tabActionsComponent: TabActionButtonsWithTitle
    }
  },

  computed: {
    detailsConfig () {
      return {
        tabs: [
          this.roadInformation
        ],
        breadcrumbs: {
          items: [
            {
              text: this.$t('road-maintenance.eRegulation')
            },
            {
              text: this.$t(this.$route.meta.breadcrumb_value)
            },
            {
              text: this.$route?.params?.id ?? this.$t('road-maintenance/aggregator.request_edit'),
              bolded: true
            }
          ]
        }
      }
    }
  },

  methods: {
    pushNotification (message) {
      if (message) {
        store.dispatch('base/notifications/push', message)
      }
    }
  }
}
</script>

<style scoped>
.main-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #F3F4F6;
}

::v-deep {
  .aggregator-requests-subject-wrapper {
    border: 1px solid #E5E7EB;
    border-radius: 16px !important;
    padding: 24px;
  }

  .aggregator-requests-internal-blocks-main {
    margin-bottom: 16px;
  }

  .aggregator-requests-internal-title {
    padding-bottom: 16px;
  }

  .modified-title {
    font-family: 'Satoshi', sans-serif !important;
    font-size: 20px !important;
    font-weight: 500;
    color: #09090B;
  }

  .generate-document-btn {
    color: #FFFFFF;
  }

  .time-period-text {
    font-family: 'Satoshi', sans-serif !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #09090B;
  }

  .time-period-column {
    padding-bottom: 0;
  }

  .aggregator-approval-blocks-main {
    width: 100%;
  }

  .aggregator-approval-card-title {
    padding-left: 10px;
  }

  .aggregator-approval-internal-title {
    font-size: 14px !important;
  }

  .aggregator-approval-card-text {
    padding-left: 0;
  }
}
</style>
